import React from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import BackdropMovementListItem from './inputs/BackdropMovementListItem';
import BackdropFilterListItem from './inputs/BackdropFilterListItem';
import BackdropRotateListItem from './inputs/BackdropRotateListItem';
import BackdropReflectionListItem from './inputs/reflection/BackdropReflectionListItem';
import BackdropHlsAdjustmentListItem from './inputs/hlsAdjustment/BackdropHlsAdjustmentListItem';
import BackdropVideoAccelerationListItem from './inputs/BackdropVideoAccelerationListItem';
import BackdropColorListItem from './inputs/BackdropColorListItem';
import { MEDIA_RESOURCE_TYPE } from '../../CreatePageConstants';

class BackdropEditor extends React.Component {
    render() {
        const { mediaSource } = this.props;
        const isColorOrGradient = mediaSource?.mediaResourceType === MEDIA_RESOURCE_TYPE.COLOR || mediaSource?.mediaResourceType === MEDIA_RESOURCE_TYPE.GRADIENT;
        // The low-impact motion controls only make sense for an actual image/video backdrop,
        // so they stay hidden for solid colors and gradients.
        const isMedia = !isColorOrGradient;

        return (
            <List
                dense
                disablePadding
            >
                <BackdropColorListItem />

                {isMedia && (
                    <React.Fragment>
                        <BackdropReflectionListItem />
                        <BackdropRotateListItem />
                        <BackdropHlsAdjustmentListItem />
                    </React.Fragment>
                )}

                <BackdropFilterListItem />

                {isMedia && (
                    <React.Fragment>
                        <BackdropVideoAccelerationListItem />
                        <BackdropMovementListItem />
                    </React.Fragment>
                )}
            </List>
        );
    }
}

const mapStateToProps = (state) => {
    const background = state.createPreview.present.videoSettings.background;
    return {
        mediaSource: background.mediaSource
    };
}

export default connect(mapStateToProps, {})(BackdropEditor);
